import find from 'lodash/find';
import { mapGetters } from 'vuex';

const SOURCES_FOR_EPISODE_MIXIN = _createOpenerMixin(false);

export default SOURCES_FOR_EPISODE_MIXIN;
export const SOURCES_FOR_CLIP_MIXIN = _createOpenerMixin(true);

const TYPES = {
   hls4: 'application/x-mpegURL',
   hls3: 'application/x-mpegURL',
   mp4: 'video/mp4'
};

function _createOpenerMixin(isClip) {
   return {
      computed: {
         sources() {
            return source(isClip ? this.clip : this.episode, this.currentLanguageLabel);
         },
         ...mapGetters(['currentLanguageLabel'])
      }
   };
}

export function source(video, langName) {
   const { type, src } = _mp4(video) || _hls(video);
   const { timecode, frameRate, name, ccUrl, thumbnailUrl, tilePreviewUrl, id, duration, episodeName } = video;
   const cc = ccUrl ? [{ label: langName || 'English', srclang: 'en', src: ccUrl, default: true }] : null;
   const title = name || episodeName;
   return { title, type, src, frameRate, timecode, cc, thumbnailUrl, preview: tilePreviewUrl, id, duration };
}

function _hls(video) {
   const source = find(video.sources, { label: 'HLS' });
   if ( !source ) {
      return null;
   }
   const src = source.uri;
   const type = TYPES[source.type];

   return { src, type };
}

function _mp4(video) {
   const type = TYPES.mp4;
   const list = video.sources.filter(s => s.type === 'mp4');

   if ( !list.length ) {
      return null;
   }
   const src = list.map(({ label, uri }) => {
      return { src: uri, name: label, default: label === '480' };
   });

   return { type, src };
}
